<template>
  <div class="email-mismatch">
    <img
      src="@/assets/illustrations/email-mismatch.png"
    >
    <h4 class="font-weight-bold">
      {{ $tk('ClientPortal.User.EmailMismatch') }}
    </h4>
    <!-- <p class="font-weight-light">
      {{ $tk('ClientPortal.User.PleaseLoginWithEmail') }}:
      <span class="font-italic">{{ userData.email }}</span>
    </p> -->
    <b-link
      @click="logout"
    >
      {{ $tk('ClientPortal.UserMenu.Logout') }}
    </b-link>
  </div>
</template>

<script>
import { logoutUser } from '../../../../GjirafaFront/script/auth'

export default {

  data() {
    return {
      // userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  methods: {
    logout() {
      localStorage.clear()
      logoutUser('auth-login')
    },
  },
}
</script>

<style lang="scss">
.email-mismatch {
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
</style>
